export const DECISION_SUPPORT_FIRST_YEAR = 2021;

export const getDecisionSupportChoosableYears = (personalDataYear?: number) => {
  const lastYear = (personalDataYear ?? DECISION_SUPPORT_FIRST_YEAR) + 1;
  const firstYear = Math.min(DECISION_SUPPORT_FIRST_YEAR, lastYear);

  return Array.from({ length: lastYear - firstYear + 1 }, (_, i) => lastYear - i);
};

export const getUpkeepCostHint = (translatedText: string, area: number, upkeepcost?: number) => {
  if (!upkeepcost) {
    return;
  }
  return `${translatedText}: ${Math.round(upkeepcost * area)} Ft`;
};
